import { Link } from "react-router-dom";
import { FormantiIcon } from "@/components/FormantiLogo";

/**
 * The top bar's frame, shared by the app navbar and the home page's header, so the two are the same height (64 px, the --nav-h token),
 * the same width and the same wordmark. `as` is "nav" or "header"; the children (links, buttons) go between the logo and the end.
 */
export function Wordmark({ to, label = "Formanti home", testId, iconClass = "h-5 sm:h-6 lg:h-8", hideBelow }) {
  return (
    <Link to={to} className="flex items-center gap-2 shrink-0 min-h-11" aria-label={label} data-testid={testId}>
      <FormantiIcon className={iconClass} />
      <span className={`${hideBelow ? "hidden min-[380px]:inline " : ""}font-heading font-bold text-lg sm:text-xl lg:text-2xl tracking-tight text-white`}>Formanti</span>
    </Link>
  );
}

export default function NavShell({ as: Tag = "nav", children, className = "", ...rest }) {
  return (
    <Tag className={`sticky top-0 z-50 border-b border-white/10 bg-zinc-950/90 md:bg-zinc-950/70 md:backdrop-blur-md ${className}`} {...rest}>
      <div className="container mx-auto px-4 max-w-7xl flex items-center justify-between gap-3 h-16">{children}</div>
    </Tag>
  );
}
